var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"swiperList",staticClass:"scrollBox",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_vm._t("main")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }